module.exports = __webpack_public_path__ + "img/dashu2.56c43cde.jpg";